import React from "react";
import { useLocation } from "react-router-dom";
import { reconcileReplayGate } from "utils/sentry/replayGate";

/**
 * Backstop for Session Replay's URL gate (utils/sentry/replayGate, REF-6708 D-B1). The gate already reacts
 * synchronously to every History API call, `popstate` and `hashchange`; this re-checks on every router location
 * in case a URL change reached the app some other way. A layout effect, so it runs before the new page's DOM
 * mutations reach the recorder. Idempotent — StrictMode's double effect is harmless. Renders nothing.
 */
const ReplayGateSync = () => {
  const { pathname, search, hash } = useLocation();
  React.useLayoutEffect(() => {
    reconcileReplayGate();
  }, [pathname, search, hash]);

  return null;
};

export default ReplayGateSync;
